<app-custom-title title="Observaciones" icon="inventory.svg"></app-custom-title>

<div>
    <mat-form-field class="text-area">
        <mat-label>Observaciones</mat-label>
        <textarea matInput placeholder="Escribe una observación..." [(ngModel)]="observation"></textarea>
    </mat-form-field>
</div>

<div class="modal-footer">
    <button mat-raised-button class="background-danger" (click)="_close()">Cancelar</button>
    <button mat-raised-button class="background-success" (click)="_save()">Guardar</button>
</div>
